<template>
  <div class="strategy-controller">
    <Wrapper v-if="true"></Wrapper>

  </div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import useAppStore from '@/store/modules/app'

/* components */
import Wrapper from './Wrapper.vue'




// 接收父组件传递的基础数据
const props = defineProps({
  baseData: {
    type: Object,
    default: () => ({})
  },
  elinkData: {
    type: Array,
    default: () => []
  },
  powerTrackingData: {
    type: Array,
    default: () => []
  }
})

// 获取 stationId
const route = useRoute()

watch(route, (nv) => {
  const id = nv.query.stationId || nv.params.stationId;
  // 守卫：首帧 URL 尚未回填 stationId 时 id 为 undefined，
  // 若直接写入会把 store 里持久化的有效值清掉，导致 Wrapper 读到空 ID
  if (!id) return;
  useAppStore().setStationId(id);
}, {deep: true, immediate: true})

onMounted(() => {

})


onUnmounted(() => {

})



</script>

<style scoped lang="scss">
.strategy-controller {
  
}
</style>
